import React, { useState } from "react";
import { BellRing, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import api, { formatApiError } from "@/lib/api";

export function AvailabilityReminder({ service, source }) {
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState("");
  const [failed, setFailed] = useState(false);
  const send = async () => {
    if (!window.confirm("Een herinnering sturen aan vrijwilligers die nog niet op deze dienst hebben gereageerd? Maximaal één herinnering per persoon per dienst per 24 uur.")) return;
    setBusy(true); setMessage(""); setFailed(false);
    try {
      const { data } = await api.post(`/availability/services/${service.id}/remind`);
      setMessage(data.queued ? `Herinnering klaargezet voor ${data.queued} vrijwilliger(s).${data.already_reminded ? ` ${data.already_reminded} ontvingen eerder al een herinnering.` : ""}` : data.unanswered ? "Deze vrijwilligers hebben de afgelopen 24 uur al een herinnering ontvangen." : "Iedereen heeft al gereageerd; er is geen herinnering nodig.");
    } catch (e) { setFailed(true); setMessage(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return <div className="mt-4 border-t pt-3 space-y-2">
    <Button variant="outline" size="sm" onClick={send} disabled={busy} data-testid={`${source}-remind-${service.id}`}>{busy ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <BellRing className="w-4 h-4 mr-2" />}Herinnering sturen</Button>
    <p className="text-xs text-muted-foreground">Alleen naar vrijwilligers zonder antwoord op deze dienst.</p>
    {message && <p role={failed ? "alert" : "status"} className={`text-xs ${failed ? "text-rose-700" : "text-red-700"}`} data-testid={`${source}-remind-result-${service.id}`}>{message}</p>}
  </div>;
}
